import React from 'react';

import { Layout } from 'antd';
import { HoyaLogo, PageContainer, SkewedEdgeContainer } from 'app/components/common';
const { Header } = Layout;

import './styles.less';

export const AppHeader = () => {
    return (
        <Header className="app-header" style={ { background: '#0056C4' } }>
            <SkewedEdgeContainer color="#0056C4" offset="22px" bottom>
                <PageContainer>
                    <HoyaLogo />
                </PageContainer>
            </SkewedEdgeContainer>
        </Header>
    );
};

AppHeader.propTypes = {
    // ...
};
